const focusOnLocationSearchInput = (path: string) => {
  setTimeout(() => {
    const wrapper = document.getElementById("search-wrapper-" + path);
    wrapper?.querySelector("input")?.parentElement?.click();
  }, 50);
};

export { focusOnLocationSearchInput };
